import React from "react";
import * as PropTypes from "prop-types";

const UIInfoSidebar = ({icon, title, description, items, tip}) => {
	return (
		<div className="info-sidebar">
			{(icon || title || description) && <div className="info-sidebar-header">
				{icon && <div className="info-sidebar-header-icon">{icon}</div>}
				<div>
					{title && <p className="info-sidebar-header-title">{title}</p>}
					{description && <p className="info-sidebar-header-description">{description}</p>}
				</div>
			</div>}
			{items.length > 0 && <div className="info-sidebar-items">
				{items.map((item, index) => (
					<div className="info-sidebar-item" key={index}>
						{item.icon && <div className="info-sidebar-item-icon">{item.icon}</div>}
						<div>
							{item.title && <p className="info-sidebar-item-title">{item.title}</p>}
							{item.description && <p className="info-sidebar-item-description">{item.description}</p>}
						</div>
					</div>
				))}
			</div>}
			{tip && (tip.title || tip.description) && <div className="info-sidebar-tip">
				<div className="info-sidebar-tip-icon">{tip.icon || <i className="fal fa-lightbulb-on" />}</div>
				<div>
					{tip.title && <p className="info-sidebar-tip-title">{tip.title}</p>}
					{tip.description && <p className="info-sidebar-tip-description">{tip.description}</p>}
				</div>
			</div>}
		</div>
	);
};

UIInfoSidebar.propTypes = {
	icon       : PropTypes.node,
	title      : PropTypes.string,
	description: PropTypes.string,
	items      : PropTypes.arrayOf(
		PropTypes.shape({
			icon       : PropTypes.node,
			title      : PropTypes.string,
			description: PropTypes.string,
		}),
	),
	tip        : PropTypes.shape({
		icon       : PropTypes.node,
		title      : PropTypes.string,
		description: PropTypes.string,
	}),
};

UIInfoSidebar.defaultProps = {
	icon       : null,
	title      : "",
	description: "",
	items      : [],
	tip        : null,
};

export default UIInfoSidebar;
